(function () {
    const trigger = document.querySelector('[data-marta-share-trigger]');
    const dialog = document.querySelector('.marta-share-dialog');

    if (!trigger || !dialog) {
        return;
    }

    const closeButton = dialog.querySelector('.marta-share-close');
    const copyButton = dialog.querySelector('.marta-share-copy');
    const copyLabel = dialog.querySelector('[data-marta-share-copy-label]');
    const status = dialog.querySelector('[data-marta-share-status]');
    const title = dialog.dataset.shareTitle;
    const url = dialog.dataset.shareUrl;
    let copyResetTimer;

    const encodedTitle = encodeURIComponent(title);
    const encodedUrl = encodeURIComponent(url);

    dialog.querySelector('[data-marta-share-facebook]').href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    dialog.querySelector('[data-marta-share-threads]').href = `https://www.threads.net/intent/post?text=${encodeURIComponent(`${title} ${url}`)}`;
    dialog.querySelector('[data-marta-share-x]').href = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
    dialog.querySelector('[data-marta-share-email]').href = `mailto:?subject=${encodedTitle}&body=${encodeURIComponent(`${title}\n\n${url}`)}`;

    function isMobilePlatform() {
        const userAgent = navigator.userAgent || '';
        const isiPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

        return /Android|iPhone|iPad|iPod/i.test(userAgent) || isiPadOS;
    }

    function resetCopyState() {
        window.clearTimeout(copyResetTimer);
        copyLabel.textContent = 'Kopiuj link';
        status.textContent = '';
    }

    function openDialog() {
        resetCopyState();
        const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        document.documentElement.style.setProperty('--marta-share-scrollbar-width', `${scrollbarWidth}px`);
        document.body.classList.add('marta-share-open');
        dialog.showModal();
        dialog.focus();
    }

    function closeDialog() {
        if (dialog.open) {
            dialog.close();
        }
    }

    function fallbackCopy(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();

        if (!copied) {
            throw new Error('Copy command failed');
        }
    }

    async function copyUrl() {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(url);
            } else {
                fallbackCopy(url);
            }

            copyLabel.textContent = 'Skopiowany';
            status.textContent = 'Link został skopiowany.';
            window.clearTimeout(copyResetTimer);
            copyResetTimer = window.setTimeout(resetCopyState, 2000);
        } catch (error) {
            status.textContent = 'Nie udało się skopiować linku.';
        }
    }

    trigger.addEventListener('click', async function (event) {
        event.preventDefault();

        if (isMobilePlatform() && typeof navigator.share === 'function') {
            try {
                await navigator.share({title, url});
                return;
            } catch (error) {
                if (error && error.name === 'AbortError') {
                    return;
                }
            }
        }

        openDialog();
    });

    closeButton.addEventListener('click', closeDialog);
    copyButton.addEventListener('click', copyUrl);

    dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
            closeDialog();
        }
    });

    dialog.addEventListener('close', function () {
        document.body.classList.remove('marta-share-open');
        document.documentElement.style.removeProperty('--marta-share-scrollbar-width');
        resetCopyState();
        trigger.focus();
    });
}());
